import React from 'react';

import {SVG} from '../svg';
import {type IconComponent} from './icon-component';

/**
 * @deprecated use MF icons
 */
export const AddPerson: IconComponent<{size?: number; className?: string}> = ({size = 30, className}) => (
    <SVG viewBox="0 0 30 30" size={size} className={className}>
        <g transform="translate(-2.5, -2.5)">
            <path
                fill="#120A20"
                d="M16.5,16.5 C13.4624339,16.5 11,14.0375661 11,11 C11,7.96243388 13.4624339,5.5 16.5,5.5 C19.5375661,5.5 22,7.96243388 22,11 C22,14.0375661 19.5375661,16.5 16.5,16.5 Z M27.5,23.65 L27.5,27.5 L5.5,27.5 L5.5,23.65 C5.5,22.573375 6.11875,21.594375 7.099125,21.15025 C8.883875,20.343125 12.111,19.25 16.5,19.25 C20.889,19.25 24.116125,20.343125 25.900875,21.15025 C26.88125,21.594375 27.5,22.573375 27.5,23.65 Z"
                id="path-1"
            />
        </g>
        <g id="Group" transform="translate(10, 11)">
            <circle id="Oval" fill="#FFFFFF" cx="11.6666667" cy="11.6666667" r="6.66666667" />
            <path
                fill="#17CF48"
                d="M10.35,10.35 L6.9,10.35 L6.9,12.65 L10.35,12.65 L10.35,16.1 L12.65,16.1 L12.65,12.65 L16.1,12.65 L16.1,10.35 L12.65,10.35 L12.65,6.9 L10.35,6.9 L10.35,10.35 Z M11.5,19.1666667 C7.26581692,19.1666667 3.83333333,15.7341831 3.83333333,11.5 C3.83333333,7.26581692 7.26581692,3.83333333 11.5,3.83333333 C15.7341831,3.83333333 19.1666667,7.26581692 19.1666667,11.5 C19.1666667,15.7341831 15.7341831,19.1666667 11.5,19.1666667 Z"
                id="path-3"
            />
        </g>
    </SVG>
);
AddPerson.isPrivate = true;
export default AddPerson;
